import { render, staticRenderFns } from "./IconNewContract.vue?vue&type=template&id=4683bf04"
import script from "./IconNewContract.vue?vue&type=script&lang=js"
export * from "./IconNewContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports